import { render } from "./ShopCategoryFilter.vue?vue&type=template&id=566fe3a4"
import script from "./ShopCategoryFilter.vue?vue&type=script&lang=js"
export * from "./ShopCategoryFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__